import { render, staticRenderFns } from "./GLYF_Question_Review.vue?vue&type=template&id=7dab2a84&scoped=true"
import script from "./GLYF_Question_Review.vue?vue&type=script&lang=js"
export * from "./GLYF_Question_Review.vue?vue&type=script&lang=js"
import style0 from "./GLYF_Question_Review.vue?vue&type=style&index=0&id=7dab2a84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dab2a84",
  null
  
)

export default component.exports